import { render, staticRenderFns } from "./chilim-text.vue?vue&type=template&id=cefd6a90&scoped=true"
import script from "./chilim-text.vue?vue&type=script&lang=js"
export * from "./chilim-text.vue?vue&type=script&lang=js"
import style0 from "./chilim-text.vue?vue&type=style&index=0&id=cefd6a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefd6a90",
  null
  
)

export default component.exports